// extracted by mini-css-extract-plugin
export default {"login-disclaimer-text":"login-disclaimer-text_iFiIX65C"};